import '.bn{position:relative;}.ssr-plugin'
import '.dv{appearance:none;}.ssr-plugin'
import '.c2{flex-shrink:0;}.ssr-plugin'
import '.ci{width:1.5rem;}.ssr-plugin'
import '.cj{height:1.5rem;}.ssr-plugin'
import '.iw{border-radius:2.125rem;}.ssr-plugin'
import '.hc{border:2px solid var(--gray-200);}.ssr-plugin'
import '.cn{background:var(--shades-white);}.ssr-plugin'
import '.d{display:flex;}.ssr-plugin'
import '.l{align-items:center;}.ssr-plugin'
import '.b6{font-style:normal;}.ssr-plugin'
import '.b5{font-weight:400;}.ssr-plugin'
import '.br{user-select:none;}.ssr-plugin'
import '.aj{gap:0.5rem;}.ssr-plugin'
import { styled } from 'inlines'
import { useId } from 'react'
import { Icon } from '../icon/Icon'
import { faCircleInfo } from '@fortawesome/pro-solid-svg-icons'
import { Tooltip } from '../tooltip/Tooltip'

export type RadioButtonProps = {
  selected: boolean
  groupName?: string
  label?: string
  labelPosition?: 'right' | 'left'
  labelSize?: 'medium' | 'small'
  disabled?: boolean
  style?: React.CSSProperties
  onClick: () => void
  tooltipText?: string
}

export const RadioButton = ({
  selected,
  groupName,
  label,
  labelPosition = 'right',
  labelSize = 'medium',
  disabled = false,
  style,
  tooltipText,
  onClick,
}: RadioButtonProps) => {
  const id = useId()
  const handler = () => {
    if (!disabled) {
      onClick()
    }
  }

  const input = (
    <styled.input className="bn dv c2 ci cj iw hc cn"
      key="input-label"
      id={id}
      name={groupName || ''}
      checked={selected}
      type="radio"
      disabled={disabled}
      onChange={handler}
      style={{
        cursor: disabled ? 'not-allowed' : 'pointer',
        '&:hover': {
          border: '2px solid var(--gray-300)',
        },
        '&:checked': {
          background: 'radial-gradient(circle at center, white 0.25rem, var(--primary-red) 0.25rem)',
          border: '2px solid var(--primary-red)',
          animation: 'radio-button-checked 0.2s ease-out',
        },
        '&:disabled': {
          background: 'var(--gray-100)',
          border: '2px solid var(--gray-200)',
        },
        '&:checked:disabled': {
          background: 'radial-gradient(circle at center, white 0.25rem, var(--shades-blue-100) 0.25rem)',
          border: '2px solid var(--shades-blue-100)',
          animation: 'radio-button-checked 0.2s ease-out',
        },

      }}
    />
  )

  const labelComponent = <styled.div key="radio-label">{label}</styled.div>
  const components = !label
    ? input
    : labelPosition === 'right'
      ? [input, labelComponent]
      : [labelComponent, input]

  return (
    <styled.label className="d l b6 b5 br"
      htmlFor={id}
      style={{
        fontSize: labelSize === 'medium' ? '1.5rem' : '1.125rem',
        cursor: disabled ? 'not-allowed' : 'pointer',
        ...style,
      }}
    >
      <div className="d l aj">
        {components}
      </div>
      {tooltipText && (
        <styled.span
        onClick={(e: React.MouseEvent) => {
          e.preventDefault()
          e.stopPropagation()
        }}>
          <Tooltip content={tooltipText}>
            <Icon 
              icon={faCircleInfo} 
              style={{ 
                color: 'var(--shades-blue-200)',
                '&:hover': { color: 'var(--primary-blue)' },
                '&:focus-visible': { color: 'var(--primary-blue)' }, 
              }} 
              size="small"
            />
          </Tooltip>
        </styled.span>
      )}
    </styled.label>
  )
}
